import { DatePicker } from '@mui/x-date-pickers'
import { FormControl, Grid, InputAdornment, InputLabel, MenuItem, OutlinedInput, Select } from '@mui/material'
import React, { forwardRef, useImperativeHandle, useMemo, useState } from 'react'
import dayjs from 'dayjs'

const TextInput = ({ value, onChange, label, adornment }) => {
  return (
    <Grid width="100%" item>
      <OutlinedInput
        onChange={(event) => {
          onChange(event.target.value)
        }}
        value={value}
        placeholder={label}
        color="secondary"
        fullWidth
        endAdornment={adornment && <InputAdornment position="end">{adornment}</InputAdornment>}
      />
    </Grid>
  )
}

export const EquipmentDetails = forwardRef(function EquipmentDetails_({ data, screens }, ref) {
  const [values, setValues] = useState({
    screenId: data.screenId || '',
    dwgNumber: data.dwgNumber || '',
    sandvikSerialNumber: data.sandvikSerialNumber || '',
    siteSerialNumber: data.siteSerialNumber || '',
    exciters: data.exciters || '',
    dateInstalled: data.dateInstalled || Date.now(),
    screenTonnage: data.screenTonnage || '',
    screenCapacity: data.screenCapacity || '',
    maintenanceFrequency: data.screenCapacity || ''
  })

  const screenMenus = useMemo(() => {
    return screens.map((s) => {
      return (
        <MenuItem key={s.id} value={s.id}>
          {s.Name}
        </MenuItem>
      )
    })
  }, [screens])

  useImperativeHandle(ref, () => {
    return {
      validate: () => {
        return {
          values
        }
      }
    }
  })

  return (
    <Grid flexDirection="column" container spacing={1.5} alignItems="center">
      <Grid width="100%" item>
        <FormControl
          sx={{
            width: '100%',
            marginTop: '.5em'
          }}>
          <InputLabel id={`select-screen`}>Select screen body</InputLabel>
          <Select
            labelId={`select-screen`}
            label="Select screen body"
            value={values.screenId}
            defaultValue=""
            onChange={(event) => {
              setValues((values) => {
                return {
                  ...values,
                  screenId: event.target.value
                }
              })
            }}
            sx={{ width: '100%' }}>
            {screenMenus}
          </Select>
        </FormControl>
      </Grid>

      <TextInput
        label="Sandvik DWG no."
        onChange={(value) => {
          setValues((values) => {
            return {
              ...values,
              dwgNumber: value
            }
          })
        }}
        value={values.dwgNumber}
      />
      <TextInput
        label="Sandvik serial no."
        onChange={(value) => {
          setValues((values) => {
            return {
              ...values,
              sandvikSerialNumber: value
            }
          })
        }}
        value={values.sandvikSerialNumber}
      />
      <TextInput
        label="Site serial no."
        onChange={(value) => {
          setValues((values) => {
            return {
              ...values,
              siteSerialNumber: value
            }
          })
        }}
        value={values.siteSerialNumber}
      />
      <TextInput
        label="Exciters"
        onChange={(value) => {
          setValues((values) => {
            return {
              ...values,
              exciters: value
            }
          })
        }}
        value={values.exciters}
      />

      <Grid item width="100%">
        <DatePicker
          sx={{
            width: '100%',
            mt: 1
          }}
          label="Date Installed"
          value={dayjs(values.dateInstalled)}
          onChange={(newValue) => {
            setValues((values) => ({
              ...values,
              dateInstalled: newValue?.valueOf()
            }))
          }}
          format="DD/MM/YYYY"
        />
      </Grid>

      <TextInput
        label="Screen tonnage"
        adornment="ton"
        onChange={(value) => {
          setValues((values) => {
            return {
              ...values,
              screenTonnage: value
            }
          })
        }}
        value={values.screenTonnage}
      />

      <TextInput
        label="Screen capacity"
        adornment="ton"
        onChange={(value) => {
          setValues((values) => {
            return {
              ...values,
              screenCapacity: value
            }
          })
        }}
        value={values.screenCapacity}
      />
      <TextInput
        label="Maintenance frequency"
        adornment="ton"
        onChange={(value) => {
          setValues((values) => {
            return {
              ...values,
              maintenanceFrequency: value
            }
          })
        }}
        value={values.maintenanceFrequency}
      />
    </Grid>
  )
})
